import { render, staticRenderFns } from "./ReportCityTgBotSection.vue?vue&type=template&id=2ae44e2a&scoped=true&"
import script from "./ReportCityTgBotSection.vue?vue&type=script&lang=js&"
export * from "./ReportCityTgBotSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae44e2a",
  null
  
)

export default component.exports
import {QBanner,QIcon,QBtn,QItem,QItemSection,QTooltip} from 'quasar'
component.options.components = Object.assign({QBanner,QIcon,QBtn,QItem,QItemSection,QTooltip}, component.options.components || {})
